<template>
  <el-container class="home-container">
    <el-header>
      <div class="span-container" style="padding: 5px" @click="toWelcome">
        <span>&nbsp;&nbsp;</span>
        <img src="../assets/deyunce.jpg" alt="" height="40px" width="40px">
        <div style="margin: 5px; font-size: 28px;font-weight: 600;">影院管理系统</div>
      </div>
      <el-button type="info" @click="logout"  style="font-size: 18px;">
         退出账号
      </el-button>
    </el-header>
    <el-container>
      <el-aside>
        <!--侧边栏菜单-->
        <el-menu
            background-color="white"
            text-color="black"
            active-text-color="grey"
            unique-opened
            :collapse-transition="false"
            :router="true"
            :default-active="$route.path">
          <!--一级菜单-->
          <el-submenu v-for="item in menuList"
                      :index="String(item.id)" :key="item.id">
            <!--一级菜单的模板区域-->
            <template slot="title">
              <!--图标-->
              <i :class="iconList[item.id]" style="font-size: 28px;color: black;"><b style="font-size: 22px;"> {{item.name}}</b></i>
              <!--文本-->
              <span> </span>
            </template>
            <!--二级菜单-->
            <el-menu-item v-for="subItem in item.children"
                          :index="'/' + subItem.path" :key="subItem.id">
              <template slot="title">
                <!--图标-->
                <i class="iconfont icon-r-find" style="font-size: 25px;color: black;"><b style="font-size: 20px;"> {{subItem.name}}</b></i>
              </template>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>



<script>
export default {
  name: "Home",
  data() {
    return {
      //左侧菜单数据
      menuList: [],
      iconList: {
        '1': 'iconfont icon-r-home',
        '2': 'iconfont icon-r-paper',
        '3': 'iconfont icon-r-building',
        '4': 'iconfont icon-r-shield',
        '5': 'iconfont icon-r-user1',
        '6': 'iconfont icon-r-user2',
        '7': 'iconfont icon-r-edit',
        '8': 'iconfont icon-r-setting',
        '99': 'el-icon-monitor'
      },
    }
  },
  created(){
    this.getMenuList()
  },
  methods: {
    async logout() {
      try {
        // 调用后端接口清除服务端缓存
        await axios.post('sysUser/logout');
      } catch (e) {
        console.warn('退出登录接口调用失败:', e.message);
      }
      // 清空本地sessionStorage
      window.sessionStorage.clear();
      this.$router.push('/login')
    },
    async getMenuList(){
      const loginUser = JSON.parse(window.sessionStorage.getItem("loginUser"))
      this.menuList = loginUser.sysUser.sysRole.children
      
      // 添加调试日志
      console.log('🏠 获取菜单数据:', {
        loginUser: loginUser?.sysUser?.userName,
        role: loginUser?.sysUser?.sysRole?.roleName,
        menuCount: this.menuList?.length,
        menuList: this.menuList
      });
      
      // 检查财务管理菜单
      const financeMenu = this.menuList?.find(menu => menu.id === 8);
      console.log('💰 财务管理菜单:', financeMenu);

      // 临时添加架构演示菜单项
      if (loginUser.sysUser.userName === 'admin') {
        this.menuList.push({
          id: 99,
          name: '架构演示',
          children: [
            { id: 991, name: '并发购票实验室', path: 'architectureDemo' }
          ]
        });
      }
      
      this.$router.push('/welcome')
    },
    toWelcome(){
      this.$router.push('/welcome')
    }
  }
}
</script>

<style scoped>

.home-container{
  height: 100%;
}

.el-header {
  background-color: white;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: black;
  font-size: 20px;
  border-bottom: 1px solid grey;
}

.el-header > div{
  display: flex;
  align-items: center;
}

div > span{
  margin-left: 15px;
}

.el-aside {
  background-color: white;
  border-right: 1px grey solid;
}

.span-container{
  cursor: pointer;
}

.el-main{
  /* background: url("../assets/welcome.jpg");
  background-size: cover; */
  background-color: white;
}

.el-menu{
  border: solid 0 grey;
}
</style>
